<!--
  indicator 接受的参数 status
  values: ['fail', 'pass', 'check', 'online', 'offline']
-->
<template>
  <div class="qm-indicator">
    <i class="qm-indicator-icon" :class="status" />
    <span class="qm-indicator-message">{{ displayStatus }}</span>
  </div>
</template>

<script>
export default {
  name: 'QmIndicator',
  props: {
    status: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    displayStatus() {
      switch (this.status) {
        case 'fail':
          return '有题目待修改'
        case 'pass':
          return '题目全部合格'
        case 'check':
          return '审核中'
        case 'online':
          return '已上线'
        case 'offline':
          return '未上线'
        case 'toStart':
          return '未开始'
        case 'onGoing':
          return '进行中'
        case 'finished':
          return '已结束'
        case 'preview':
          return '预览状态'
        default:
          return ''
      }
    },
  },
}
</script>

<style scoped></style>
